import BrandclubStoreConfigUtils from "./brandclubStoreConfigUtils";

export class Logger {
    private static readonly LOG_LEVELS = {
        DEBUG: 0,
        INFO: 1,
        WARN: 2,
        ERROR: 3,
        NONE: 4
    } as const;

    private logLevel: number;
    private context: string;

    constructor(context: string, stage = BrandclubStoreConfigUtils.getAppStage()) {
        this.context = context;
        // Set default log level based on stage
        this.logLevel = stage === 'prod' ? Logger.LOG_LEVELS.ERROR : (stage === 'localhost' ? Logger.LOG_LEVELS.DEBUG : Logger.LOG_LEVELS.INFO);
    }

    private formatMessage(level: string, message: string, ...args: unknown[]): void {
        const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
        const formattedMessage = `[${level}] [${timestamp}] [${this.context}] ${message}`;

        const consoleMethods: Record<string, (...args: unknown[]) => void> = {
            // eslint-disable-next-line no-console
            'DEBUG': console.debug,
            // eslint-disable-next-line no-console
            'INFO': console.info,
            // eslint-disable-next-line no-console
            'WARN': console.warn,
            // eslint-disable-next-line no-console
            'ERROR': console.error
        };

        // eslint-disable-next-line no-console
        const consoleMethod = consoleMethods[level] || console.log;

        if (args.length > 0) {
            consoleMethod(formattedMessage, ...args);
        } else {
            consoleMethod(formattedMessage);
        }
    }

    debug(message: string, ...args: unknown[]): void {
        if (this.logLevel <= Logger.LOG_LEVELS.DEBUG) {
            this.formatMessage('DEBUG', message, ...args);
        }
    }

    info(message: string, ...args: unknown[]): void {
        if (this.logLevel <= Logger.LOG_LEVELS.INFO) {
            this.formatMessage('INFO', message, ...args);
        }
    }

    warn(message: string, ...args: unknown[]): void {
        if (this.logLevel <= Logger.LOG_LEVELS.WARN) {
            this.formatMessage('WARN', message, ...args);
        }
    }

    error(message: string, ...args: unknown[]): void {
        if (this.logLevel <= Logger.LOG_LEVELS.ERROR) {
            this.formatMessage('ERROR', message, ...args);
        }
    }

    setLogLevel(level: keyof typeof Logger.LOG_LEVELS): void {
        this.logLevel = Logger.LOG_LEVELS[level];
    }
}
